interface GetTotalPriceLabelProps {
  isFlightIncluded?: boolean;
  isHotelIncluded?: boolean;
  isTicketIncluded?: boolean;
}

/**
 * Returns a formatted label string based on what's included in the package
 * @param props - Object containing boolean flags for what's included
 * @returns A string describing what's included in the total price
 */
export function getTotalPriceLabel({
  isFlightIncluded = false,
  isHotelIncluded = false,
  isTicketIncluded = true, // Tickets are always included by default
}: GetTotalPriceLabelProps): string {
  const includedItems: string[] = ['taxes'];

  if (isTicketIncluded) {
    includedItems.push('tickets');
  }

  if (isHotelIncluded) {
    includedItems.push('hotel');
  }

  if (isFlightIncluded) {
    includedItems.push('flights');
  }

  // Format the items with proper comma and "& " before the last item
  if (includedItems.length === 1) {
    return `Includes ${includedItems[0]}`;
  }

  const lastItem = includedItems.pop();
  return `Includes ${includedItems.join(', ')} & ${lastItem}`;
}
